// True only on a mobile phone (not desktop, not tablet/iPad).
// Drivers must start & drive trips from a phone for safety + reliable GPS.
export function isPhone() {
  if (typeof navigator === "undefined" || typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  const isIPad = /iPad/i.test(ua) || (navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1);
  if (isIPad) return false;
  const phoneUA = /iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|BB10|Opera Mini|IEMobile/i.test(ua);
  const touch = (navigator.maxTouchPoints || 0) > 0 || "ontouchstart" in window;
  const small = Math.min(window.innerWidth, window.innerHeight) <= 820;
  return phoneUA && touch && small;
}
